<template>
  <v-row>
    <v-col cols="12"
           :class="`text-center pb-3 main-text ${headerFontSize}`">
      <slot name="header"></slot>
    </v-col>
    <v-col cols="12">
      <v-form ref="contact"
              lazy-validation>
        <v-row>
          <v-col md="6"
                 cols="12"
                 :class="{'pa-3': !isMobileView}">
            <v-row>
              <v-col cols="12"
                     class="ma-1">
                <v-text-field solo
                              v-model="from"
                              label="E-mail"
                              :rules="[rules.required, rules.email]"></v-text-field>
              </v-col>
              <v-col cols="12"
                     class="ma-1">
                <v-textarea counter="600"
                            v-model="msg"
                            solo
                            label="Treść"
                            :rules="[rules.required]"></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="6"
                 cols="12"
                 :class="{'pa-3': !isMobileView}">
            <v-row>
              <v-col cols="12">
                <v-checkbox :rules="[v => !!v || '']">
                  <template slot="label">
                    <span class="body-1">
                      Wyrażam zgodę na przetwarzanie przez firmę OnGeo sp. z
                      o.o. z siedzibą w Krakowie, ul. Wadowicka 8A, 30-415
                      Kraków, KRS: 0000565289, moich danych osobowych
                      zawartych w niniejszym formularzu, w celu udzielenia
                      odpowiedzi na wysłane zapytanie. Podanie danych jest
                      dobrowolne, ale niezbędne do przetworzenia zapytania.
                      <span style="color:red">*</span>
                    </span>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12">
                <details>
                  <summary>Administratorem Państwa danych osobowych jest firma OnGeo sp. z o.o. z siedzibą w Krakowie, ul. Wadowicka 8A, 30-415 Kraków.</summary>Informujemy, że Państwa zgoda może zostać cofnięta w dowolnym momencie przez wysłanie wiadomości e-mail na adres
                  <a href="mailto: kontakt@ongeo.pl"
                     aria-label="kontakt@ongeo.pl">Administratora danych OnGeo</a> z adresu,
                  którego zgoda dotyczy. Państwa dane nie będą przekazywane poza EOG ani udostępniane organizacjom
                  międzynarodowym. Posiadają Państwo prawo do żądania od administratora dostępu do swoich danych
                  osobowych, prawo do ich sprostowania, usunięcia lub ograniczenia przetwarzania, prawo do wniesienia
                  sprzeciwu wobec przetwarzania, prawo do przenoszenia danych.
                  <br>Więcej informacji dotyczących
                  przetwarzania danych osobowych znajdziecie Państwo w naszej
                  <router-link :to="{name: 'regulation'}">Polityce Prywatności</router-link>.
                </details>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4"
                 offset-md="4"
                 cols="12"
                 offset-xs="0"
                 class="pt-3">
            <VueOnGeoButton :block="true"
                            text="Wyślij wiadomość"
                            primaryColor="primary"
                            :click="send"></VueOnGeoButton>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
    <VueOnGeoOkDialog :dialog="dialog"></VueOnGeoOkDialog>
  </v-row>
</template>

<script>
import VueOnGeoDialogsMixin from "./vue-ongeo-dialogs-mixin.js";
import VueOnGeoButton from "./vue-ongeo-button.vue";
import VueOnGeoOkDialog from "./vue-ongeo-ok-dialog.vue";
import VueOnGeoGlobalMixin from "./vue-ongeo-global-mixin.js";

import axios from "axios";

export default {
  name: "ContactForm",
  mixins: [VueOnGeoDialogsMixin, VueOnGeoGlobalMixin],
  components: { VueOnGeoButton, VueOnGeoOkDialog },
  props: {
    url: { type: String, required: true }
  },
  data: function () {
    return {
      rules: {
        required: value => !!value || "Wypełnij to pole.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Nieprawidłowy adres e-mail.";
        }
      },
      msg: "",
      from: ""
    };
  },
  methods: {
    send () {
      if (this.$refs.contact.validate()) {
        let msg = {
          from: this.from,
          msg: this.msg
        };
        axios.post(this.url, msg).then(
          () => {
            this.dialog.text = "Wiadomość została wysłana.";
            this.dialog.show = true;
            this.clear();
          },
          () => {
            this.dialog.text =
              "Błąd podczas wysyłania wiadomość. Proszę spróbować poźniej.";
            this.dialog.show = true;
          }
        );
      }
    },
    clear () {
      this.msg = "";
      this.from = "";
    }
  }
};
</script>
